export const verifyCC = (form, cardKnoxState) => {
  if (
    cardKnoxState &&
    cardKnoxState["card-number"]?.isValid &&
    cardKnoxState?.cvv?.isValid &&
    form?.creditCardInformation?.ExpirationDate
  ) {
    return true;
  } else {
    return false;
  }
};
